import { useEffect } from "react"
import type { ReactElement, ReactNode } from "react"
import { Popup } from "react-leaflet"
import { usePrevious } from "../../../hooks"

import "./leaflet-popup.styles.scss"

export interface ILeafletPopupProps {
  open: boolean
  className?: string
  children?: ReactNode
  marker: L.Marker
}

export function LeafletPopup(props: ILeafletPopupProps): ReactElement {
  const { open, className, children, marker } = props
  const previousOpen: boolean | undefined = usePrevious<boolean>(open)
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    if (previousOpen !== open) {
      togglePopup()
    }
  }, [open])

  function togglePopup(): void {
    if (open) {
      marker.openPopup()
    } else {
      marker.closePopup()
    }
  }

  function keepOpen(): void {
    if (open) {
      setTimeout(() => marker.openPopup(), 0)
    }
  }

  return (
    <Popup
      closeButton={false}
      closeOnClick={false}
      closeOnEscapeKey={false}
      autoClose={false}
      onClose={keepOpen}
      className={`controlled-leaflet-popup ${className || ""}`}
    >
      {children}
    </Popup>
  )
}
